import Type from "typebox";

export const DEFAULT_PAGE_SIZE = 50 as const;
export const MAX_PAGE_SIZE = 100 as const;

export const CursorSchema = Type.String({
  minLength: 1,
  maxLength: 512,
  pattern: "^[A-Za-z0-9_-]+$",
  description: "Opaque server-issued pagination cursor.",
});

export const CursorPaginationQuerySchema = Type.Object(
  {
    cursor: Type.Optional(CursorSchema),
    limit: Type.Optional(
      Type.Integer({
        default: DEFAULT_PAGE_SIZE,
        minimum: 1,
        maximum: MAX_PAGE_SIZE,
      }),
    ),
  },
  {
    $id: "CursorPaginationQuery",
    additionalProperties: false,
  },
);

export const PageInfoSchema = Type.Object(
  {
    nextCursor: Type.Optional(CursorSchema),
    hasMore: Type.Boolean(),
  },
  {
    $id: "PageInfo",
    additionalProperties: false,
  },
);

export const PaginatedResponseSchema = <T extends Type.TSchema>(itemSchema: T) =>
  Type.Object(
    {
      items: Type.Array(itemSchema),
      page: PageInfoSchema,
    },
    { additionalProperties: false },
  );

export type Cursor = Type.Static<typeof CursorSchema>;
export type CursorPaginationQuery = Type.Static<typeof CursorPaginationQuerySchema>;
export type PageInfo = Type.Static<typeof PageInfoSchema>;
